import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "quiz" }
const _hoisted_2 = { class: "quiz__bg" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "quiz__top" }
const _hoisted_5 = { class: "quiz__top-wrap" }
const _hoisted_6 = {
  class: "quiz__progress",
  style: {"background":"url('/images/quiz-progress-empty.svg') no-repeat"}
}
const _hoisted_7 = {
  class: "quiz__step",
  style: {"background":"url('/images/quiz-step-bg.svg')"}
}
const _hoisted_8 = { class: "quiz__question" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "quiz__answer" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "quiz__modal-wrap" }
const _hoisted_13 = { class: "quiz__modal-top" }
const _hoisted_14 = { class: "quiz__modal-top-wrap" }
const _hoisted_15 = { class: "quiz__modal-content" }
const _hoisted_16 = { class: "quiz__modal-chat" }
const _hoisted_17 = { class: "quiz__modal-bottom" }
const _hoisted_18 = { class: "quiz__modal-bottom-wrap" }
const _hoisted_19 = { class: "quiz__modal-achievement" }
const _hoisted_20 = ["src"]

import DecorTitle from "@/components/uikit/DecorTitle.vue";
import UserPoints from "@/components/uikit/UserPoints.vue";
import GreenButton from "@/components/uikit/GreenButton.vue";
import { useGameStore } from "@/stores/index";
import { ref, computed, onMounted, watch } from "vue";
import router from "@/router";
import { getImagePath } from "@/utils/image";

interface Dialog {
  position: string;
  text: string;
}

interface Skill {
  name: string;
  imageUrl: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'QuizScreen',
  setup(__props) {

const store = useGameStore();
const background = ref("/images/quiz-bg-1.jpg");
const modalActive = ref(false);
const dialogs = ref<Dialog[]>([]);
const skills = ref<Skill[]>([]);
const disableButton = ref(false);

// Активный шаг вопроса
const step = ref(
  store.playerInfoArray?.answeredQuestions?.length &&
    store.playerInfoArray.answeredQuestions.length > 0
    ? store.playerInfoArray.answeredQuestions.length
    : 1
);

// Заполнение прогресс бара
const progressValue = computed(() => {
  const starWidth = 26;
  const starMargin = 8;
  const fullStars = Number(step.value);
  const partialStar = Number(step.value) - fullStars;
  const fillWidth =
    fullStars * (starWidth + starMargin) + partialStar * starWidth;
  const maxWidth = (fillWidth / 196) * 100;
  return maxWidth;
});

// Открытие модального окна
const openModal = (id: number) => {
  const question = store.quizList[step.value - 1];
  const selectedAnswer = question?.answers.find((answer) => answer.id === id);

  dialogs.value = selectedAnswer?.dialog ?? [];
  skills.value = selectedAnswer?.values ?? [];

  store.answerQuestion(question?.id, id);
  disableButton.value = false;
  modalActive.value = true;
};

// Переход к следующему шагу
const nextStep = () => {
  if (disableButton.value) return;

  disableButton.value = true;

  if (step.value <= store.quizList.length - 1) {
    modalActive.value = false;
    setTimeout(() => (step.value += 1), 200);
  } else {
    router.push("/identification");
  }
};

watch(
  () => store.playerInfoArray?.answeredQuestions,
  (newValue) => {
    if (newValue) {
      if (newValue.length > 0) {
        step.value = newValue.length;
      } else {
        step.value = 1;
      }
    }
  },
  { immediate: true }
);

watch(step, (newStep) => {
  const index = ((newStep - 1) % 3) + 1;
  background.value = `/images/quiz-bg-${index}.jpg`;
});

onMounted(() => {
  store.getQuiz();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: background.value,
        alt: ""
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(DecorTitle, {
        title: 'Новая миссия',
        icon: '/images/quiz-icon-top.svg'
      }),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(UserPoints, {
          count1: _unref(store).playerScore
        }, null, 8, ["count1"]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", {
            class: "quiz__progress-current",
            style: _normalizeStyle([{"background":"url('/images/quiz-progress-full.svg') no-repeat"}, 'max-width: ' + progressValue.value + '%'])
          }, null, 4)
        ]),
        _createElementVNode("div", _hoisted_7, _toDisplayString(step.value), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "quiz__question-title" }, "МИФИСТ ОДНАЖДЫ МИФИСТ НАВСЕГДА", -1)),
      _createElementVNode("div", {
        class: "quiz__question-wrap",
        innerHTML: _unref(store).quizList[step.value - 1]?.text
      }, null, 8, _hoisted_9),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "quiz__question-decor" }, [
        _createElementVNode("img", {
          src: "/images/quiz-questions-decor.svg",
          alt: ""
        })
      ], -1)),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "quiz__question-decor quiz__question-decor--logo" }, [
        _createElementVNode("img", {
          src: "/images/quiz-questions-decor-2.svg",
          alt: ""
        })
      ], -1))
    ]),
    _createElementVNode("div", _hoisted_10, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "quiz__answer-title" }, [
        _createTextVNode("Как поступишь "),
        _createElementVNode("span", null, "ты?")
      ], -1)),
      _createElementVNode("div", {
        class: _normalizeClass(["quiz__answer-items", {
          'quiz__answer-items--2':
            _unref(store).quizList[step.value - 1]?.answers.length === 2,
        }])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).quizList[step.value - 1]?.answers, (item, i) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "quiz__answer-item",
            key: i,
            onClick: ($event: any) => (openModal(item.id))
          }, [
            _createElementVNode("span", null, _toDisplayString(item.answer), 1)
          ], 8, _hoisted_11))
        }), 128))
      ], 2)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["quiz__modal", { 'quiz__modal--active': modalActive.value }])
    }, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(store).quizList[step.value - 1]?.title), 1)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dialogs.value, (item, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["quiz__modal-item", {
                'quiz__modal-item--right': item.position === 'right',
                'quiz__modal-item--left': item.position === 'left',
              }]),
                key: i
              }, _toDisplayString(item.text), 3))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createVNode(DecorTitle, {
                title: 'Открыты ценности',
                icon: '/images/modal-icon-decor.svg',
                small: true
              }),
              _createElementVNode("div", _hoisted_19, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(skills.value, (item, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: i,
                    class: "quiz__modal-achievement-item"
                  }, [
                    _createElementVNode("img", {
                      src: _unref(getImagePath)(item.imageUrl),
                      alt: ""
                    }, null, 8, _hoisted_20)
                  ]))
                }), 128))
              ])
            ]),
            _createVNode(GreenButton, { onClick: nextStep }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createTextVNode("К следующей миссии")
              ])),
              _: 1
            })
          ])
        ])
      ])
    ], 2)
  ]))
}
}

})